// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedKeratoscopySummary_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 9C7.433 9 9 7.433 9 5.5C9 3.567 7.433 2 5.5 2C3.567 2 2 3.567 2 5.5C2 7.433 3.567 9 5.5 9ZM18.5 9C20.433 9 22 7.433 22 5.5C22 3.567 20.433 2 18.5 2C16.567 2 15 3.567 15 5.5C15 7.433 16.567 9 18.5 9ZM5.5 22C7.433 22 9 20.433 9 18.5C9 16.567 7.433 15 5.5 15C3.567 15 2 16.567 2 18.5C2 20.433 3.567 22 5.5 22ZM18.5 22C20.433 22 22 20.433 22 18.5C22 16.567 20.433 15 18.5 15C16.567 15 15 16.567 15 18.5C15 20.433 16.567 22 18.5 22ZM5.5 11C8.53757 11 11 8.53757 11 5.5C11 2.46243 8.53757 0 5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11ZM18.5 11C21.5376 11 24 8.53757 24 5.5C24 2.46243 21.5376 0 18.5 0C15.4624 0 13 2.46243 13 5.5C13 8.53757 15.4624 11 18.5 11ZM11 18.5C11 21.5376 8.53757 24 5.5 24C2.46243 24 0 21.5376 0 18.5C0 15.4624 2.46243 13 5.5 13C8.53757 13 11 15.4624 11 18.5ZM18.5 24C21.5376 24 24 21.5376 24 18.5C24 15.4624 21.5376 13 18.5 13C15.4624 13 13 15.4624 13 18.5C13 21.5376 15.4624 24 18.5 24Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedKeratoscopySummary is a generated icon component.
 */
let IconMedKeratoscopySummary = IconMedKeratoscopySummary_1 = class IconMedKeratoscopySummary extends IconBaseElement {
    render() {
        return html `${IconMedKeratoscopySummary_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedKeratoscopySummary.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedKeratoscopySummary = IconMedKeratoscopySummary_1 = __decorate([
    customElement('zui-icon-med-keratoscopy-summary')
], IconMedKeratoscopySummary);
export { IconMedKeratoscopySummary };
